<template>
    <div v-if="word" class="foot">
        <div class="foot-info">
            <div class="foot-left">
                <div class="product-section">
                    <div class="foot-title">{{word.foot.product.title[language]}}</div>
                    <div @click="toSMS" class="product-item">{{word.menu.sms[language]}}</div>
                    <div @click="toVoice" class="product-item">{{word.menu.voice[language]}}</div>
                    <div @click="toPlatform" class="product-item">{{word.menu.phone[language]}}</div>
                </div>
                <div class="about">
                    <div class="foot-title">{{word.foot.company.title[language]}}</div>
                    <div class="company-info">
                        <span class="info-label">{{word.foot.company.email[language]}}:</span>
                        <a href="mailto:service@code-notification.com">service@code-notification.com</a>
                    </div>
                    <div class="company-info">
                        <span class="info-label">{{word.foot.company.address[language]}}:</span>
                        <span>{{word.foot.company.specific[language]}}</span>
                    </div>
                    <div class="company-info terms">
                        <span @click="goToTermsService">{{word.foot.company.TermsService[language]}}</span>
                    </div>
                    <div class="company-info privacy">
                        <span @click="goToPrivacyPolicy">{{word.foot.company.PrivacyPolicy[language]}}</span>
                    </div>
                </div>
            </div>
            <!-- <div class="foot-right">
                <div class="qr">
                    <img src="./../assets/LinkedIn.png" alt="">
                    <div>{{language == 'CN' ? '公司领英' : 'LinkedIn Company Page'}}</div>
                </div>
                <div class="qr">
                    <img src="./../assets/facebook.png" alt="">
                    <div>{{language == 'CN' ? '公司FACEBOOK' : 'Facebook Company Page'}}</div>
                </div>
                <div class="qr">
                    <img src="./../assets/wechat.jpg" alt="">
                    <div>{{language == 'CN' ? '微信公众号' : 'Wechat Office Account'}}</div>
                </div>
            </div> -->
        </div>
        <div class="copyright">
            <div>Copyright © 2021-2025 Heyou-tech.</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'foot',
    props: {
        reload: Boolean,
        word: Object
    },
    data() {
        return {
            language: null
        }
    },
    created() {
        this.language = localStorage.getItem('language')
    },
    watch: {
        reload:function () {
            this.language = localStorage.getItem('language')
        }
    },
    methods: {
        toDoc() {
            this.$router.push({path: '/docment'})
        },
        toSMS(e) {
            this.$router.push({path: '/sms'})
        },
        toVoice() {
            this.$router.push({path: '/voice'})
        },
        toPlatform() {
            this.$router.push({path: '/platform'})
        },
        goToTermsService() {
            this.$router.push({path: '/termsService'})
        },
        goToPrivacyPolicy() {
            this.$router.push({path: '/privacyPolicy'})
        }
    }

}
</script>

<style lang="scss" scoped>
    .foot {
        background-color: #0f557b;
        color: #eee;
        .foot-info {
            padding: 40px 5%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .foot-left {
                display: flex;
                flex-wrap: wrap;
                width: 100%;
                @media (min-width: 768px) {
                    width: 80%;
                }
                .product-section, .about {
                    margin: 20px;
                    flex: 1 1 200px;
                    min-width: 200px;
                    .product-item {
                        margin: 15px 0;
                        font-size: 14px;
                        cursor: pointer;
                        transition: color 0.3s;
                        &:hover {
                            color: #108ccf;
                        }
                    }
                }
                .about {
                    max-width: 300px;
                    .company-info {
                        margin: 15px 0;
                        font-size: 14px;
                        line-height: 1.5;
                        .info-label {
                            font-weight: 600;
                            display: block;
                        }
                        a {
                            color: #eee!important;
                            text-decoration: underline;
                            &:hover {
                                color: #108ccf!important;
                            }
                        }
                        &.terms, &.privacy {
                            span {
                                cursor: pointer;
                                text-decoration: underline;
                                transition: color 0.3s;
                                &:hover {
                                    color: #108ccf;
                                }
                            }
                        }
                    }
                }
                .foot-title {
                    cursor: text;
                    font-size: 18px;
                    color: #cccccc;
                    font-weight: 600;
                    margin-bottom: 28px;
                    position: relative;
                    padding-bottom: 10px;
                    &::after {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 40px;
                        height: 2px;
                        background-color: #108ccf;
                    }
                }
            }
            .foot-right {
                padding-top: 30px;
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                width: 100%;
                @media (min-width: 768px) {
                    width: 20%;
                }
                .qr {
                    width: 100px;
                    text-align: center;
                    margin: 10px;
                    img {
                        width: 100%;
                        margin-bottom: 10px;
                        border-radius: 5px;
                    }
                }
            }
        }
        .copyright {
            width: 90%;
            margin: 0 auto;
            padding: 20px 0;
            border-top: 1px solid #999;
            text-align: center;
            font-size: 13px;
            div {
                margin-top: 5px;
            }
        }
    }
</style>